<script>
  export let percent = 0;
  export let usedGB = '0';
  export let totalGB = '0';
  export let freeGB = '0';
  export let perApp = [];
  export let showPerApp = false;

  function getColor(pct) {
    if (pct >= 80) return 'var(--neon-red)';
    if (pct >= 60) return 'var(--neon-orange)';
    return 'var(--neon-purple)';
  }

  function bytesToGB(bytes) {
    return (bytes / (1024 ** 3)).toFixed(1);
  }
</script>

<div class="monitor-card card">
  <div class="monitor-header">
    <div class="card-title">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <rect x="2" y="6" width="20" height="12" rx="2"/><line x1="6" y1="12" x2="6" y2="12"/><line x1="10" y1="12" x2="10" y2="12"/>
        <circle cx="6" cy="12" r="1" fill="currentColor"/><circle cx="10" cy="12" r="1" fill="currentColor"/>
      </svg>
      {showPerApp ? 'Memory Usage (Per App)' : 'Memory Usage'}
    </div>
    <button class="toggle-view" on:click={() => showPerApp = !showPerApp} id="toggle-memory-view">
      {showPerApp ? '← System View' : 'App Breakdown →'}
    </button>
  </div>

  {#if !showPerApp}
    <div class="system-view" id="memory-system-view">
      <div class="big-stat">
        <span class="stat-value" style="color: {getColor(percent)}">{percent}%</span>
        <span class="stat-label">Total Memory</span>
      </div>
      <div class="progress-bar">
        <div class="progress-fill" style="width: {percent}%; background: {getColor(percent)}"></div>
      </div>
      <div class="stat-details">
        <span class="detail-used">{usedGB}GB</span>
        <span class="detail-sep">/</span>
        <span>{totalGB}GB</span>
        <span class="detail-sep">•</span>
        <span>{freeGB}GB free</span>
      </div>
    </div>
  {:else}
    <div class="per-app-view" id="memory-perapp-view">
      {#each perApp as app}
        <div class="app-mem-row">
          <div class="app-mem-info">
            <span class="app-mem-name">{app.name}</span>
            <div class="app-mem-stats">
              <span class="app-mem-pct" style="color: {getColor(app.percent)}">{app.percent}%</span>
              <span class="app-mem-bytes">{bytesToGB(app.bytes)}GB</span>
            </div>
          </div>
          <div class="progress-bar">
            <div class="progress-fill" style="width: {Math.min(app.percent * 2, 100)}%; background: {getColor(app.percent)}"></div>
          </div>
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
  .monitor-card {
    animation: fadeInUp 0.4s ease 0.1s both;
  }

  .monitor-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .monitor-header .card-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 0;
  }

  .monitor-header .card-title svg {
    color: var(--neon-purple);
  }

  .toggle-view {
    padding: 6px 14px;
    font-size: 12px;
    color: var(--neon-blue);
    border: 1px solid rgba(59, 130, 246, 0.3);
    border-radius: var(--radius-sm);
    background: rgba(59, 130, 246, 0.08);
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .toggle-view:hover {
    background: rgba(59, 130, 246, 0.15);
    border-color: var(--neon-blue);
  }

  .system-view {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .big-stat {
    display: flex;
    align-items: baseline;
    gap: 10px;
  }

  .stat-value {
    font-size: 42px;
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1;
  }

  .stat-label {
    font-size: 14px;
    color: var(--text-secondary);
    font-weight: 500;
  }

  .stat-details {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: var(--text-secondary);
    margin-top: 4px;
  }

  .detail-used { color: var(--text-primary); font-weight: 600; }
  .detail-sep { opacity: 0.4; }

  .per-app-view {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .app-mem-row {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .app-mem-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .app-mem-name {
    font-size: 13px;
    font-weight: 500;
    color: var(--text-primary);
  }

  .app-mem-stats {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .app-mem-pct {
    font-size: 14px;
    font-weight: 700;
  }

  .app-mem-bytes {
    font-size: 12px;
    color: var(--text-secondary);
  }
</style>
